<script>
    import Vue from 'vue';
    import BaseVue from '@frontend/Base.vue';
    import Gen from '../../helper/Gen';

    export default {
        extends: BaseVue,
        data() {},
        mounted() {},
        methods: {},
        watch: {},
    };
</script>

<template>
	<section id="content" class="overflow-none">
		<div class="content-wrap">
			<section class="section not-found nobg nobottommargin notopmargin">
				<div class="container">
					<div class="row justify-content-center">
						<div class="col-md-6 order-1 order-md-0">
							<div class="heading-block">
								<h2>Halaman yang anda cari tidak dapat ditemukan</h2>
							</div>
							<h4>Beberapa Tautan ini mungkin bisa membantu</h4>
							<div class="nf-links">
								<ul>
									<li><router-link :to="{name:'DirectMail'}">{{ web.mn_dm }}</router-link></li>
									<li><router-link :to="{name:'Karir'}">{{ web.mn_karir }}</router-link></li>
									<li><router-link :to="{name:'AboutUs'}">{{ web.mn_tentang }}</router-link></li>
									<li><router-link :to="{name:'Contact'}">{{ web.mn_contact }}</router-link></li>
								</ul>
							</div>
							<router-link :to="{name:'index'}" class="btn btn-primary">Kembali ke Beranda</router-link>
						</div>
						<div class="col-md-6 order-0 order-md-1">
							<VImg :src="baseUrl+'/frontend/images/404.png'" alt="Image 404"></VImg>
						</div>
					</div>
				</div>
			</section>
		</div>
	</section>
</template>